// Generated by CoffeeScript 2.7.0
var DateTimePickerPopover;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import DateTimePicker from 'trunks/vue/admin/components/libs/date_time_picker.js';

import RangePicker from 'trunks/vue/admin/components/libs/range_picker.js';

export default DateTimePickerPopover = Vue.extend({
  components: {
    popover: Popover,
    'datetime-picker': DateTimePicker,
    'range-picker': RangePicker
  },
  props: {
    initValue: [Object, Date],
    viewMode: {
      type: String,
      default: 'date'
    },
    position: {
      type: String,
      default: 'bottom left'
    },
    modeChangeable: {
      type: Boolean,
      default: true
    },
    customClass: String,
    limitStart: Date,
    limitEnd: Date,
    blockContent: {
      type: Boolean,
      default: true
    },
    rangable: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      value: null,
      viewType: this.viewMode,
      dynamicType: 'static',
      rangePosition: 'start'
    };
  },
  template: `<popover :position='position'
         :caret='false'
         :customClass="['datetimepicker-popover', customClass, rangeClass]"
         type='select'
         ref='popover'
         :blockContent='blockContent'
         :size='popoverSize'
         @beforeOpen='beforeOpenPopover'
         @beforeClose='beforeClosePopover'>
  <template slot='trigger'>
    <slot name='trigger'>
      <div class="input-control right-addon" v-if="rangable">
        <div class="controlled-input bordered">
          <div class="text-ellipsis">{{ rangText }}</div>
        </div>
        <div class="addon">
          <i :class="iconClass"></i>
        </div>
      </div>
      <div class="input-control right-addon" v-else>
        <input type="text" placeholder='请选择' readonly v-model.trim='displayValue' />
        <div class="addon">
          <i class="slp-date-time"></i>
        </div>
      </div>
    </slot>
  </template>
  <template slot='content'>
    <template v-if="rangable">
      <range-picker ref='rangePicker'
                    :initValue='value'
                    :viewMode='viewMode'
                    :limitEnd='limitEnd'
                    :limitStart='limitStart'
                    :modeChangeable='modeChangeable'
                    @viewModeChanged='updateViewMode'
                    @dynamicTypeChanged='dynamicTypeChangeFunc'
                    @ensureClicked='ensureRange' />
    </template>
    <template v-else>
      <datetime-picker ref='datetimePicker'
                       :initValue='value'
                       :viewMode='viewMode'
                       :limitEnd='limitEnd'
                       :limitStart='limitStart'
                       @viewModeChanged='updateViewMode' />
      <div class="popover-select-footer">
        <div class="btn text-btn" @click='selectCurrent'>立即</div>
        <div class="btn text-btn" @click='switchViewMode' v-if='modeChangeable'>
          {{ viewType === 'date' ? '选时间' : '选日期' }}
        </div>
        <div class="btn text-btn" @click='ensureClicked'>确认</div>
      </div>
    </template>
  </template>
</popover>`,
  created: function() {
    if (this.rangable) {
      return this.value = this.initValue;
    } else {
      return this.value = this.initValue || new Date();
    }
  },
  computed: {
    format: function() {
      if (this.modeChangeable) {
        return 'YYYY-MM-DD hh:mm';
      } else {
        if (this.viewType === 'date') {
          return 'YYYY-MM-DD';
        } else {
          return 'hh:mm';
        }
      }
    },
    displayValue: function() {
      if (this.value) {
        return this.value.strftime(this.format);
      } else {
        return '';
      }
    },
    popoverSize: function() {
      if (this.rangable) {
        return 'large';
      } else {
        return '';
      }
    },
    rangeClass: function() {
      if (this.rangable) {
        return 'expand-content';
      } else {
        return '';
      }
    },
    iconClass: function() {
      if (this.modeChangeable) {
        return 'slp-date-time';
      } else {
        return 'slp-date';
      }
    },
    start: function() {
      var _result, ref;
      _result = (ref = this.value) != null ? ref['start'] : void 0;
      if (!_result) {
        return;
      }
      if (this.dynamicType === 'dynamic' && (_result != null ? _result.split(' ')[0].trim() : void 0) === 'null') {
        return null;
      }
      return _result;
    },
    end: function() {
      var _result, ref;
      _result = (ref = this.value) != null ? ref['end'] : void 0;
      if (!_result) {
        return;
      }
      if (this.dynamicType === 'dynamic' && (_result != null ? _result.split(' ')[0].trim() : void 0) === 'null') {
        return null;
      }
      return _result;
    },
    startText: function() {
      return this._stringifyRangeText(this.start);
    },
    endText: function() {
      return this._stringifyRangeText(this.end);
    },
    rangText: function() {
      if (this.startText && this.endText) {
        return `${this.startText} ~ ${this.endText}`;
      } else {
        if (this.startText) {
          return `${this.startText} 之后`;
        } else if (this.endText) {
          return `${this.endText} 之前`;
        } else {
          return "开始时间  ~  结束时间";
        }
      }
    }
  },
  methods: {
    switchViewMode: function() {
      var ref;
      return (ref = this.$refs.datetimePicker) != null ? ref.switchViewMode() : void 0;
    },
    updateViewMode: function(viewMode) {
      return this.viewType = viewMode;
    },
    selectCurrent: function() {
      var ref;
      if ((ref = this.$refs.datetimePicker) != null) {
        ref.setValue(new Date());
      }
      return this.$nextTick(function() {
        return this.ensureClicked();
      });
    },
    beforeClosePopover: function() {
      var ref;
      // sync value to picker
      if (this.rangable) {
        return;
      }
      return (ref = this.$refs.datetimePicker) != null ? ref.setValue(this.value) : void 0;
    },
    dynamicTypeChangeFunc: function() {
      return this.$nextTick(function() {
        return this.$refs.popover.calculatePosition();
      });
    },
    rangeReset: function() {
      var ref;
      this.value = null;
      return (ref = this.$refs.rangePicker) != null ? ref.destroyValueIfNeed() : void 0;
    },
    ensureClicked: function() {
      var ref;
      this.value = (ref = this.$refs.datetimePicker) != null ? ref.getValue() : void 0;
      this.$emit('valueChanged', this.value);
      return this.$refs.popover.close();
    },
    ensureRange: function(range, dynamicType) {
      this.value = range;
      this.dynamicType = dynamicType;
      this.$emit('valueChanged', range, dynamicType);
      return this.$refs.popover.close();
    },
    beforeOpenPopover: function() {
      return this.$emit('beforeOpenPopover');
    },
    setDatetimepickerValue: function(value) {
      return this.$nextTick(function() {
        return this.$refs.datetimePicker.setValue(value);
      });
    },
    _stringifyRangeText: function(value) {
      if (!value) {
        return;
      }
      if (this.dynamicType === 'static') {
        if (value) {
          return value.strftime(this.format);
        } else {
          return '';
        }
      } else {
        return Skylark.Helpers.Utilities.stringifyFilter(value);
      }
    }
  }
});
